import { Box, BoxProps } from '@mantine/core';
import { ReactNode } from 'react';
import classes from './PickerSectionBox.module.css';

type Props = BoxProps & { children: ReactNode };

/** The bordered box a people picker's search-and-results section sits in. */
export function PickerSectionBox({ children, ...boxProps }: Props) {
  return (
    <Box className={classes.box} {...boxProps}>
      {children}
    </Box>
  );
}
